import {FC, useEffect} from "react";
import {ScheduleModalProps} from "./types";
import {Modal, Spin} from "antd";
import {useStaffController} from "../../../../controllers/staff-controller";
import {Query} from "appwrite";
import ScheduleForm from "./components/schedule-form/ScheduleForm";

const ScheduleModal: FC<ScheduleModalProps> = (props) => {
  const {scheduleController} = props
  const {isCreateModalOpen, scheduleForm, toggleCreateModalVisible, selectedSchedule} = scheduleController
  const {isLoading, staffList, fetchStaffList} = useStaffController()
  const isDataLoading = isLoading || scheduleController.isLoading

  useEffect(() => {
    fetchStaffList([Query.equal("role", "doctor")])
  }, [])


  const okButtonHandler = () => {
    scheduleForm.submit()
  }

  const title = selectedSchedule ? "Редагувати" : "Додати"

  return <Modal destroyOnClose title={title} open={isCreateModalOpen} onCancel={toggleCreateModalVisible}
                okText="Зберегти"
                cancelText="Cкасувати"
                onOk={okButtonHandler}>
    <Spin spinning={isDataLoading}>
      <ScheduleForm scheduleController={scheduleController} staffList={staffList}/>
    </Spin>
  </Modal>
}

export default ScheduleModal
